import { ReactElement } from "react";

import { TableControls } from "~frontend/components/Table";

import { USER_INVITE_SORTS, USER_SORTS } from "./constants";
import { UserStatus } from "./types";

export default function UserListControls({
  statusFilter,
  setStatusFilter,
  sort,
  setSort,
  search,
  setSearch,
  onClickInvite,
  onClickGetInviteLink,
}: {
  statusFilter: UserStatus;
  setStatusFilter: (newStatus: UserStatus) => void;
  sort: string;
  setSort: (newSort: string) => void;
  search: string;
  setSearch: (newSearch: string) => void;
  onClickInvite: () => void;
  onClickGetInviteLink?: () => void;
}): ReactElement {
  return (
    <TableControls
      addButtons={[
        ...(onClickGetInviteLink
          ? [
              {
                label: "Get Invite Link",
                id: "get-invite-link",
                icon: <></>,
                onClick: onClickGetInviteLink,
              },
            ]
          : []),
        { label: "Invite User", id: "invite-user", onClick: onClickInvite },
      ]}
      filters={[
        {
          id: "status",
          label: "User Status",
          value: statusFilter,
          onChange: (value: string) => setStatusFilter(value as UserStatus),
          options: [
            { value: UserStatus.INVITED, label: "Invited" },
            { value: UserStatus.ACTIVE, label: "Active" },
          ],
        },
      ]}
      sort={{
        value: sort,
        onChange: setSort,
        options:
          statusFilter === UserStatus.INVITED ? USER_INVITE_SORTS : USER_SORTS,
      }}
      search={{
        value: search,
        onChange: setSearch,
        placeholder: "Search for a user...",
      }}
    />
  );
}
